import axios from "axios";
import { AUTHENTICATION_ENDPOINT } from "./APIEndpoints";
axios.defaults.withCredentials = true;
export const authJWT = async (token) => {
    try {
      const res = await axios.post(`${AUTHENTICATION_ENDPOINT}/jwt`, {token});
      axios.defaults.headers.common['Authorization'] = res.headers.getAuthorization();
      return res.data;
    } catch (err) {
      console.error(err.response);
      throw err;
    }
  };